import React, { useCallback, useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import PostPageLinkPost from 'components/PostPageLinkPost';
import PostPagePhotoPost from 'components/PostPagePhotoPost';
import PostPageDiscussionPost from 'components/PostPageDiscussionPost';
import fetchApi from 'hooks/fetchApi';
import API_NAME from 'services/api';

import {
  BackButton,
  PostComponent,
  LoadingComponent,
  ContentContainer,
} from 'components';
import { getPostDetailsStart, clearPostDetailsData } from 'store/posts/actions';
import {
  likeEvent,
  likePost,
  unlikeEvent,
  unlikePost,
} from 'services/likePost';
import { getLocalStorage } from 'utils/hooks';
import { AsyncStatus } from 'utils/types';
import { routesPath } from 'utils/constants/routePath';
import {
  openSidebarComments,
  actionTypes,
  openSidebarLikes,
} from 'store/sideBarControler/actions';
import { ThemeContext } from 'theme';
import fetchData from 'utils/fetchData';
import PrivateContent from 'components/PrivateContent/PrivateContent';
import {
  BackButtonWrap,
  PostDetailsWrap,
  ContentWrap,
} from './post_details.style';
import { useTranslation } from 'react-i18next';

const PostDetails = ({
  postId,
  staticData,
}: {
  postId: string;
  staticData: any;
}) => {
  const router = useRouter();
  const { t } = useTranslation();
  const userDetails = useSelector((store) => store.user?.userDetails);
  const context: any = useContext(ThemeContext);
  const [data, setData] = useState(staticData?.data || {});
  console.log('🚀 ~ file: [id].page.tsx ~ line 44 ~ data', data);
  const { action } = fetchApi();
  const [isLike, setIsLike] = useState(false);
  const [likes, setLikes] = useState(data?.likes?.length || 0);
  const dispatch = useDispatch();

  const onCommentsClick = (id: string, postType: string) => {
    dispatch(
      openSidebarComments({
        actionType: actionTypes.OPEN_SIDEBAR_COMMENTS,
        commentsPostId: id,
        commentsType: postType,
      })
    );
  };

  const onLikesCountClick = (id: string, type: number) => {
    // dispatch(
    //   openSidebarLikes({
    //     postId: id,
    //     postType: type,
    //   })
    // );
  };

  const onLikeClick = () => {
    setIsLike(!isLike);
    if (isLike) {
      action(API_NAME.UNLIKE_POSTS, {
        params: {
          postId: data?._id,
        },
      });
      setLikes(likes - 1);
      return;
    }
    action(API_NAME.LIKE_POSTS, {
      params: {
        postId: data?._id,
      },
    });
    setLikes(likes + 1);
  };

  const isGroup = data?.origin === 'group';

  useEffect(() => {
    setIsLike(staticData?.data?.likes?.includes(context?.userId) || false);
  }, []);

  return (
    <ContentContainer>
      <PostDetailsWrap>
        <BackButtonWrap>
          <BackButton />
        </BackButtonWrap>
        <ContentWrap>
          {/* <ContentWrap>{renderPostCard()}</ContentWrap> */}
          {data?.type === 1 && (
            <PostPagePhotoPost
              profilePhoto={
                isGroup
                  ? data?.group?.profilePhoto
                  : data?.creator?.profilePhoto
              }
              userId={isGroup ? data?.group?._id : data?.creator?._id}
              creatorId={isGroup ? data?.group?._id : data?.creator?._id}
              username={
                isGroup ? data?.group?.username : data?.creator?.username
              }
              fullname={
                isGroup ? data?.group?.username : data?.creator?.username
              }
              isVerified={
                isGroup ? data?.group?.isVerified : data?.creator?.isVerified
              }
              isAmbassador={
                isGroup
                  ? data?.group?.isAmbassador
                  : data?.creator?.isAmbassador
              }
              isDonor={isGroup ? data?.group?.isDonor : data?.creator?.isDonor}
              followingStatus={data?.followingStatus}
              isMe={data?.isMine}
              postTime={data?.datetime}
              mediaObjects={data?.mediaObjects}
              origin={data?.origin}
              users={data?.users}
              groups={data?.groups}
              events={data?.events}
              text={data?.text}
              geoLocation={data?.geoLocation}
              locationName={
                isGroup ? data?.group?.location?.address : data?.location?.name
              }
              isLike={isLike}
              likes={likes}
              id={data?._id}
              originId={data?.originId}
              commentsCount={data?.comments?.length}
              sharesCount={data?.shares}
              data={data}
              onCommentClick={(id) => onCommentsClick(id, data?.origin)}
              onLikesCountClick={(id) => onLikesCountClick(id, data?.type)}
              onLikeClick={onLikeClick}
            />
          )}
          {data?.type === 3 && (
            <PostPageLinkPost
              profilePhoto={
                isGroup
                  ? data?.group?.profilePhoto
                  : data?.creator?.profilePhoto
              }
              userId={isGroup ? data?.group?._id : data?.creator?._id}
              creatorId={isGroup ? data?.group?._id : data?.creator?._id}
              username={
                isGroup ? data?.group?.username : data?.creator?.username
              }
              fullname={
                isGroup ? data?.group?.username : data?.creator?.username
              }
              isVerified={
                isGroup ? data?.group?.isVerified : data?.creator?.isVerified
              }
              isAmbassador={
                isGroup
                  ? data?.group?.isAmbassador
                  : data?.creator?.isAmbassador
              }
              isDonor={isGroup ? data?.group?.isDonor : data?.creator?.isDonor}
              followingStatus={data?.followingStatus}
              geoLocation={data?.geoLocation}
              isMe={data?.isMine}
              postTime={data?.datetime}
              // mediaObjects={data?.mediaObjects}
              link={data?.link}
              linkImage={data?.linkImage}
              linkTitle={data?.linkTitle}
              linkHost={data?.linkHost}
              origin={data?.origin}
              users={data?.users}
              groups={data?.groups}
              events={data?.events}
              text={data?.text}
              locationName={
                isGroup ? data?.group?.location?.address : data?.location?.name
              }
              isLike={isLike}
              likes={likes}
              id={data?._id}
              originId={data?.originId}
              commentsCount={data?.comments?.length}
              sharesCount={data?.shares}
              data={data}
              onCommentClick={(id) => onCommentsClick(id, data?.origin)}
              onLikesCountClick={(id) => onLikesCountClick(id, data?.type)}
              onLikeClick={onLikeClick}
            />
          )}
          {data.type === 11 && (
            <PostPageDiscussionPost
              profilePhoto={
                isGroup
                  ? data?.group?.profilePhoto
                  : data?.creator?.profilePhoto
              }
              userId={isGroup ? data?.group?._id : data?.creator?._id}
              creatorId={isGroup ? data?.group?._id : data?.creator?._id}
              username={
                isGroup ? data?.group?.username : data?.creator?.username
              }
              fullname={
                isGroup ? data?.group?.username : data?.creator?.username
              }
              isVerified={
                isGroup ? data?.group?.isVerified : data?.creator?.isVerified
              }
              isAmbassador={
                isGroup
                  ? data?.group?.isAmbassador
                  : data?.creator?.isAmbassador
              }
              title={data.title}
              isDonor={isGroup ? data?.group?.isDonor : data?.creator?.isDonor}
              followingStatus={data?.followingStatus}
              isMe={data?.isMine}
              geoLocation={data?.geoLocation}
              postTime={data?.datetime}
              mediaObjects={data?.mediaObjects}
              origin={data?.origin}
              users={data?.users}
              groups={data?.groups}
              events={data?.events}
              text={data?.text}
              locationName={
                isGroup ? data?.group?.location?.address : data?.location?.name
              }
              isLike={isLike}
              likes={likes}
              id={data?._id}
              originId={data?.originId}
              commentsCount={data?.comments?.length}
              sharesCount={data?.shares}
              data={data}
              onCommentClick={(id) => onCommentsClick(id, data?.origin)}
              onLikesCountClick={(id) => onLikesCountClick(id, data?.type)}
              onLikeClick={onLikeClick}
            />
          )}
        </ContentWrap>
      </PostDetailsWrap>
      <PrivateContent
        showButton={!userDetails?._id}
        buttonText={t('event:loginCreateAccount')}
        data={data}
        onButtonClick={() => {
          router.push({
            pathname: routesPath.authentication,
            query: { redirect: router.asPath }, // Store current route
          });
        }}
      />
    </ContentContainer>
  );
};

export default PostDetails;

export async function getServerSideProps({ query, req, res }) {
  let tsec = req?.cookies?.tsec;

  if (!tsec) {
    const loginAnonymousResp = await fetchData(
      `${process.env._DB_HOST}api/v11/auth/${process.env._ANONYMOUS_USERNAME}`,
      {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password: process.env._ANONYMOUS_PASSWORD }),
        isAuthenticated: false,
      }
    ).then((resp) => resp.json());

    if (loginAnonymousResp.data.ok) {
      tsec = loginAnonymousResp.data.token;
    }
  }

  const response = await fetchData(
    `${process.env._DB_HOST}api/v01/media/${query.id}`,
    {
      method: 'GET',
      headers: { tsec, clubId: req?.cookies?.clubId },
    }
  );
  const data = await response.json();

  return {
    props: {
      staticData: data,
      postId: query.id,
    },
  };
}
